import { IndicatorGoalSaveRequestDto } from '../dto/request/indicator-goal-save-request.dto';
import { IndicatorGoalUpdateRequestDto } from '../dto/request/indicator-goal-update-request.dto';
import { IndicatorGoalResponseDto } from '../dto/response/indicator-goal-response.dto';
import { BaseLandscapeService } from '../../base-landscape.service';

class IndicatorGoalService extends BaseLandscapeService {
  public async fetchIndicatorGoalById(
    id: string
  ): Promise<IndicatorGoalResponseDto> {
    const response = await this.get<IndicatorGoalResponseDto>(
      `/indicatorgoal/${id}`
    );
    return response.data;
  }

  public async fetchIndicatorGoalsByGoalId(
    goalId: string
  ): Promise<IndicatorGoalResponseDto[]> {
    const response = await this.get<IndicatorGoalResponseDto[]>(
      `/indicatorgoal/getbygoalid/${goalId}`
    );
    return response.data;
  }

  public async fetchIndicatorGoalsByIndicatorId(
    indicatorId: string
  ): Promise<IndicatorGoalResponseDto[]> {
    const response = await this.get<IndicatorGoalResponseDto[]>(
      `/indicatorgoal/getbyindicatorid/${indicatorId}`
    );
    return response.data;
  }

  public async saveIndicatorGoal(
    saveRequest: IndicatorGoalSaveRequestDto
  ): Promise<IndicatorGoalResponseDto> {
    const response = await this.post<IndicatorGoalResponseDto>(
      `/indicatorgoal`,
      saveRequest
    );
    return response.data;
  }

  public async updateIndicatorGoal(
    updateRequest: IndicatorGoalUpdateRequestDto
  ): Promise<IndicatorGoalResponseDto> {
    const response = await this.put<IndicatorGoalResponseDto>(
      `/indicatorgoal`,
      updateRequest
    );
    return response.data;
  }

  public async deleteIndicatorGoal(existingId: string): Promise<void> {
    await this.delete<void>(`/indicatorgoal/${existingId}`);
  }
}

const indicatorGoalService = new IndicatorGoalService();
export default indicatorGoalService;
